import { useTranslation } from 'modules/segmentation/hooks';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { AnyComparator, DefaultComparator, RegexComparator } from 'modules/queryBuilder/types';
import { SelectOption } from 'modules/queryBuilder/contexts';
import { isInvalidComparatorFromOptions } from '../utils';

export const useComparatorOptionsWithInvalidComparator = (
  comparator: AnyComparator | null,
  options: SelectOption<string>[],
) => {
  const { t } = useTranslation();
  const hasRegexComparators = useFeatureFlag('UseRegexInSearchQuery');

  if (!isInvalidComparatorFromOptions(comparator, options)) return options;

  const defaultComparators = Object.values(DefaultComparator).map((comparator) => ({
    value: comparator,
    title: t(`comparators.default.${comparator}`),
  }));

  const regexComparators = hasRegexComparators
    ? Object.values(RegexComparator).map((comparator) => ({
        value: comparator,
        title: t(`comparators.regex.${comparator}`),
      }))
    : [];

  const invalidComparatorOptions = [...regexComparators, ...defaultComparators]
    .filter(({ value }) => value === comparator)
    .map(({ value, title }) => ({
      value,
      title,
      isDisabled: true,
      tooltipContent: t('comparators.disabledComparatorTooltip'),
    }));

  return [...invalidComparatorOptions, ...options];
};
